<template>
  <DoctorDashboardCard>
    <template v-slot:title>
      <h3>
        <v-icon class="primary--text pr-2">error_outline</v-icon>
        Vérification mensuelle du dossier patient
        <v-chip v-show="patients.length">{{patients.length}}</v-chip>
      </h3>
    </template>
    <template v-slot:text>
      <v-list v-if="patients.length"
              two-line>
        <template v-for="(patient, index) in patients">
          <span :key="patient.id">
            <span>
              <span>{{patient.first_name}} {{patient.last_name}}</span>
            </span>

            <span>
              <v-btn icon
                     @click="checkPatient(patient.id)"
                     ripple>
                <v-icon color="primary">arrow_forward</v-icon>
              </v-btn>
            </span>

          </span>
          <v-divider v-if="index + 1 < patients.length"></v-divider>
        </template>
      </v-list>
      <h2 v-else
          class="text-center pb-5"
          style="color: #757575">Aucune vérification ÉTAPES en attente.</h2>
    </template>
    <template v-slot:info-text>
      Le dossier de chaque patient doit être consulté une fois par mois par un membre de l'équipe soignante. Cliquez sur la flèche pour accéder au profil patient et le noter comme vérifié.
    </template>
  </DoctorDashboardCard>
</template>

<script>
  import api from 'api'
  import DoctorDashboardCard from 'components/Iriade/DoctorDashboardCard'

  export default {
    components: {
      DoctorDashboardCard
    },

    data () {
      return {
        patients: [],
        ui: {
          loading: true
        }
      }
    },

    methods: {
      checkPatient (patient_id) {
        api.post(`diabnext/patients/${patient_id}/check`).then(_ => {
          this.$mango.snackbar({
            color: 'success',
            text: "Suivi ÉTAPE validé"
          })
          this.$router.push({name: 'patients@find',
            params: {
              patient_id: patient_id,
              moduleName: 'suivi'
            }
          })
        }).catch(_ => {
          this.$mango.snackbar({
            color: 'error',
            text: "Une erreur est survenue"
          })
        })
      }
    },

    mounted () {
      api.get(`dashboard/modules/find`, {params: {class_name: this.module.class_name}})
        .then(res => {
          this.ui.loading = false
          this.patients = res.data
        })
    },

    props: ['module']
  }
</script>
